// Países con bandera, nombre y código telefónico para react-select
// label → texto buscable y visible | value → código de marcación

export const COUNTRIES = [
  // América Latina (primero por contexto del portfolio)
  { value: "+54", label: "🇦🇷 Argentina (+54)" },
  { value: "+598", label: "🇺🇾 Uruguay (+598)" },
  { value: "+34", label: "🇪🇸 España (+34)" },
  { value: "+1", label: "🇺🇸 Estados Unidos (+1)" },
  { value: "+506", label: "🇨🇷 Costa Rica (+506)" },
  { value: "+591", label: "🇧🇴 Bolivia (+591)" },
  { value: "+52", label: "🇲🇽 México (+52)" },
  { value: "+56", label: "🇨🇱 Chile (+56)" },
  { value: "+57", label: "🇨🇴 Colombia (+57)" },
  { value: "+51", label: "🇵🇪 Perú (+51)" },
  { value: "+55", label: "🇧🇷 Brasil (+55)" },
  { value: "+53", label: "🇨🇺 Cuba (+53)" },
  { value: "+593", label: "🇪🇨 Ecuador (+593)" },
  { value: "+503", label: "🇸🇻 El Salvador (+503)" },
  { value: "+502", label: "🇬🇹 Guatemala (+502)" },
  { value: "+509", label: "🇭🇹 Haití (+509)" },
  { value: "+504", label: "🇭🇳 Honduras (+504)" },
  { value: "+505", label: "🇳🇮 Nicaragua (+505)" },
  { value: "+507", label: "🇵🇦 Panamá (+507)" },
  { value: "+595", label: "🇵🇾 Paraguay (+595)" },
  { value: "+1787", label: "🇵🇷 Puerto Rico (+1787)" },
  { value: "+1809", label: "🇩🇴 República Dominicana (+1809)" },
  { value: "+58", label: "🇻🇪 Venezuela (+58)" },

  // América del Norte
  { value: "+1", label: "🇨🇦 Canadá (+1)" },

  // Europa
  { value: "+49", label: "🇩🇪 Alemania (+49)" },
  { value: "+43", label: "🇦🇹 Austria (+43)" },
  { value: "+32", label: "🇧🇪 Bélgica (+32)" },
  { value: "+359", label: "🇧🇬 Bulgaria (+359)" },
  { value: "+385", label: "🇭🇷 Croacia (+385)" },
  { value: "+45", label: "🇩🇰 Dinamarca (+45)" },
  { value: "+421", label: "🇸🇰 Eslovaquia (+421)" },
  { value: "+386", label: "🇸🇮 Eslovenia (+386)" },
  { value: "+372", label: "🇪🇪 Estonia (+372)" },
  { value: "+358", label: "🇫🇮 Finlandia (+358)" },
  { value: "+33", label: "🇫🇷 Francia (+33)" },
  { value: "+30", label: "🇬🇷 Grecia (+30)" },
  { value: "+36", label: "🇭🇺 Hungría (+36)" },
  { value: "+353", label: "🇮🇪 Irlanda (+353)" },
  { value: "+354", label: "🇮🇸 Islandia (+354)" },
  { value: "+39", label: "🇮🇹 Italia (+39)" },
  { value: "+371", label: "🇱🇻 Letonia (+371)" },
  { value: "+370", label: "🇱🇹 Lituania (+370)" },
  { value: "+352", label: "🇱🇺 Luxemburgo (+352)" },
  { value: "+356", label: "🇲🇹 Malta (+356)" },
  { value: "+31", label: "🇳🇱 Países Bajos (+31)" },
  { value: "+48", label: "🇵🇱 Polonia (+48)" },
  { value: "+351", label: "🇵🇹 Portugal (+351)" },
  { value: "+44", label: "🇬🇧 Reino Unido (+44)" },
  { value: "+420", label: "🇨🇿 República Checa (+420)" },
  { value: "+40", label: "🇷🇴 Rumania (+40)" },
  { value: "+7", label: "🇷🇺 Rusia (+7)" },
  { value: "+381", label: "🇷🇸 Serbia (+381)" },
  { value: "+46", label: "🇸🇪 Suecia (+46)" },
  { value: "+41", label: "🇨🇭 Suiza (+41)" },
  { value: "+380", label: "🇺🇦 Ucrania (+380)" },

];

// Opción por defecto: Argentina
export const DEFAULT_COUNTRY = COUNTRIES[0];
